/* cw-pdp.js · PDP Wonder Skin v40 (team LIQUID-PDP) · classic script, defer.
   Conversion of prototype/assets/js/pages/product.js + the PDP part of prototype src/js/product-ui.mjs (syncPdp, sticky).
   Gallery (swipe / thumbnails / arrows / keyboard) · lightbox (focus trap, Esc, arrows, Zoom 2x, click to zoom at the
   point) · product video slide (slide 2: lazy attach after load + idle, plays only while visible, pause/play button,
   once-and-rest for "film", video in the lightbox) · variant photo (the selected format's own photo, also on ?variant=) · format sync (price, strike-through, "−N%" badge and Omnibus line only for a real reduction, unit, legend, line total, stock, sticky
   select, mother <-> travel line, ?variant= in the URL) · quantity · dynamic free shipping line · links that open a
   closed accordion · "Visti di recente" · "Aggiungi la routine" (ONE window.CW.addItems() call).
   NO submit listener and NO click listener on the PDP form or its ATC buttons: the only owner of the add to cart is
   handlePdpSubmit() in assets/global.js (form.pdp-form + [data-sticky-atc]). This file emits `cw:variant-change`
   {product, variant, form} after updating the UI (prototype contract, CONTRIBUTING.md). */
(function () {
  'use strict';
  var root = document.querySelector('[data-cw-pdp]');
  var dataEl = document.querySelector('[data-cw-pdp-json]');
  if (!root || !dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var form = document.getElementById('PdpForm');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // B2 (CRO08): this section script runs BEFORE cw-v40-core.js (defer order), so window.CW is read at use time.
  function cwg() { return window.CW || null; }

  /* ---------- helpers ---------- */
  function money(c) {
    var CWG = cwg();
    if (CWG && typeof CWG.money === 'function') return CWG.money(c);
    var n = (Number(c) || 0) / 100;
    var parts = n.toFixed(2).split('.');
    return '€' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
  }
  var live = null;
  function announce(msg) {
    var CWG = cwg();
    if (CWG && typeof CWG.announce === 'function') { CWG.announce(msg); return; }
    if (!live) {
      live = document.createElement('p');
      live.className = 'cw-sr';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 30);
  }
  var store = {
    get: function (k, d) { try { var v = window.localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } }
  };
  function variantById(id) {
    for (var i = 0; i < D.variants.length; i++) if (String(D.variants[i].id) === String(id)) return D.variants[i];
    return null;
  }
  document.body.classList.add('has-sticky-atc');

  /* ---------- gallery ---------- */
  var gal = qs('[data-cw-gallery]');
  var track = gal && qs('[data-cw-pg-track]', gal);
  var slides = track ? qsa('[data-cw-pg-slide]', track) : [];
  var thumbs = gal ? qsa('[data-cw-pg-thumb]', gal) : [];
  var cur = 0;
  function setCurrent(i, say) {
    if (i === cur && !say) return;
    cur = i;
    var c = qs('[data-cw-pg-i]', gal); if (c) c.textContent = String(i + 1);
    thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    if (say) { var l = qs('[data-cw-pg-live]', gal); if (l) l.textContent = (slides[i] && qs('[data-cw-pg-video]', slides[i]) ? 'Video ' : 'Immagine ') + (i + 1) + ' di ' + slides.length; }
    vSync();
  }
  function galRelease() { if (track) track.classList.remove('cw-pg__track--boot'); } // A6 P1: slides 2+ visible before any move
  function goTo(i, say) {
    if (!slides.length) return;
    galRelease();
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    setCurrent(i, say);
  }
  if (track && slides.length > 1) {
    var raf = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { setCurrent(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)), false); });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowRight' || k === 'ArrowLeft' || k === 'Home' || k === 'End') {
        e.preventDefault();
        goTo(k === 'Home' ? 0 : k === 'End' ? slides.length - 1 : cur + (k === 'ArrowRight' ? 1 : -1), true);
      } else if (k === 'Enter') { e.preventDefault(); openZoom(cur, track); }
    });
  }
  if (gal) {
    gal.addEventListener('click', function (e) {
      if (e.target.closest('[data-cw-pg-vbtn]')) { vToggle(); return; }
      var t = e.target.closest('[data-cw-pg-thumb]');
      if (t) { goTo(Number(t.getAttribute('data-cw-pg-thumb')), true); return; }
      var s = e.target.closest('[data-cw-pg-step]');
      if (s) { goTo(cur + Number(s.getAttribute('data-cw-pg-step')), true); return; }
      var z = e.target.closest('[data-cw-pg-zoom]');
      if (z) { openZoom(cur, z); return; }
      if (e.target.closest('.cw-pg__frame') && !e.target.closest('.cw-pg__frame--empty')) openZoom(cur, qs('[data-cw-pg-zoom]', gal));
    });
  }

  /* ---------- variant photo: the selected format shows its own photo ----------
     data-cw-vmedia (gallery) = {variantId: featured_media id | null}; slides carry data-cw-media-id. Own photo -> its
     slide; travel variant without its own photo -> the other format's first photo (extra slide); else slide 0. */
  var vMedia = {};
  try { vMedia = JSON.parse((gal && gal.getAttribute('data-cw-vmedia')) || '{}') || {}; } catch (e) { vMedia = {}; }
  function slideForVariant(v) {
    if (!v || !slides.length) return 0;
    var mid = vMedia[String(v.id)];
    for (var i = 0; mid && i < slides.length; i++) if (slides[i].getAttribute('data-cw-media-id') === String(mid)) return i;
    var sib = qs('[data-cw-pdp-sibling]');
    if (sib && String(v.id) === sib.getAttribute('data-travel-variant')) {
      for (var k = 0; k < slides.length; k++) if (slides[k].hasAttribute('data-cw-pg-extra')) return k;
    }
    return 0;
  }
  function showVariantMedia(v, instant) {
    if (!track || slides.length < 2) return;
    galRelease();
    var i = slideForVariant(v);
    var im = qs('img', slides[i]); if (im && im.loading === 'lazy') im.loading = 'eager'; // lazy photo off screen: load it now
    if (instant) { track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'auto' }); setCurrent(i, false); }
    else if (i !== cur) goTo(i, false);
  }

  /* ---------- product video (slide 2, [data-cw-pg-video]) ----------
     No src in the HTML. After window load + idle the MP4 is attached the first time the slide is visible; autoplay
     (muted, inline) only with prefers-reduced-motion: no-preference and without Save-Data; otherwise the poster stays
     and the button offers a manual play. Plays only while the slide is visible in the track (IntersectionObserver on
     the slide: the track clips the other slides) and the tab is visible; pauses when it leaves or the lightbox opens.
     "film" (no loop attribute): plays once, rests on the last frame, is not restarted automatically. */
  var vid = track ? qs('[data-cw-pg-video]', track) : null;
  var vSlide = vid ? vid.closest('[data-cw-pg-slide]') : null;
  var vBtn = vSlide ? qs('[data-cw-pg-vbtn]', vSlide) : null;
  var vReady = false, vSeen = false, vUser = null, vDone = false;
  function motionOK() {
    var c = navigator.connection;
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) && !(c && c.saveData);
  }
  function vAttach() {
    if (!vid || vid.__cwSrc) return;
    vid.__cwSrc = true;
    var img = qs('img', vSlide);
    if (img && img.currentSrc) vid.setAttribute('poster', img.currentSrc);
    var so = document.createElement('source');
    so.src = vid.getAttribute('data-src');
    so.type = 'video/mp4';
    vid.appendChild(so);
    vid.load();
  }
  function vUI() {
    if (!vBtn) return;
    vBtn.hidden = !vReady || !!vid.__cwErr;
    var on = !vid.paused && !vid.ended;
    vBtn.classList.toggle('is-playing', on);
    vBtn.setAttribute('aria-label', on ? 'Metti in pausa il video' : vDone ? 'Riproduci di nuovo il video' : 'Riproduci il video');
  }
  function vPlay() {
    vAttach();
    var p = vid.play();
    if (p && p.catch) p.catch(function () { vUI(); /* autoplay refused: the poster stays */ });
  }
  function vSync() {
    if (!vid) return;
    var visible = vSeen && !document.hidden && !(zoom && !zoom.hidden);
    if (!vReady || vid.__cwErr) { vUI(); return; }
    if (!visible) { if (!vid.paused) vid.pause(); vUI(); return; }
    var want = vUser === 'play' || (vUser === null && motionOK() && !vDone);
    if (want && vid.paused && !(vDone && vUser !== 'play')) vPlay();
    else if (!want && !vid.paused) vid.pause();
    vUI();
  }
  function vToggle() {
    if (!vid || !vReady) return;
    if (!vid.paused && !vid.ended) { vUser = 'pause'; vid.pause(); }
    else { vUser = 'play'; vDone = false; vPlay(); }
    vUI();
  }
  if (vid) {
    vid.addEventListener('playing', function () { vid.classList.add('is-on'); vUI(); });
    vid.addEventListener('pause', vUI);
    vid.addEventListener('ended', function () { vDone = true; vUser = null; vUI(); });
    vid.addEventListener('error', function () { vid.__cwErr = true; vid.classList.remove('is-on'); vUI(); }, true);
    document.addEventListener('visibilitychange', vSync);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { vSeen = en[0].isIntersecting; vSync(); }, { threshold: 0.6 }).observe(vSlide);
    }
    var vIdle = function (fn) { if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2500 }); else setTimeout(fn, 300); };
    var vLoad = function () { vIdle(function () { vReady = true; vSync(); }); };
    if (document.readyState === 'complete') vLoad(); else window.addEventListener('load', vLoad);
  }

  /* ---------- lightbox (own dialog: focus trap, Esc, focus back to the opener) ---------- */
  var zoom = document.getElementById('PdpZoom');
  var zImg = zoom && qs('[data-cw-zoom-img]', zoom);
  var zStage = zoom && qs('[data-cw-zoom-stage]', zoom);
  var zVid = zoom && qs('[data-cw-zoom-video]', zoom);
  var zToggle = zoom && qs('[data-cw-zoom-toggle]', zoom);
  var zi = 0, zOpener = null, zPrevOverflow = '';
  function setZoomed(on) {
    zStage.classList.toggle('is-zoomed', on);
    var b = qs('[data-cw-zoom-toggle]', zoom); if (b) b.setAttribute('aria-pressed', String(on));
    if (on) { zStage.scrollLeft = (zStage.scrollWidth - zStage.clientWidth) / 2; zStage.scrollTop = (zStage.scrollHeight - zStage.clientHeight) / 2; }
  }
  function zoomShow(i) {
    if (!slides.length) return;
    zi = (i + slides.length) % slides.length;
    var img = qs('img', slides[zi]);
    if (!img) return;
    var isV = !!(zVid && qs('[data-cw-pg-video]', slides[zi]) && !(vid && vid.__cwErr));
    if (zVid) {
      if (isV) {
        if (!zVid.__cwSrc) {
          zVid.__cwSrc = true;
          zVid.setAttribute('poster', slides[zi].getAttribute('data-cw-zoom-src') || img.currentSrc);
          var so = document.createElement('source');
          so.src = zVid.getAttribute('data-src'); so.type = 'video/mp4';
          so.addEventListener('error', function () { zVid.__cwErr = true; zVid.hidden = true; zImg.hidden = false; });
          zVid.appendChild(so);
          zVid.load();
        }
        if (vid && vid.currentTime && !zVid.currentTime) { try { zVid.currentTime = vid.currentTime; } catch (e) { /* not seekable yet */ } }
        if (motionOK()) { var p = zVid.play(); if (p && p.catch) p.catch(function () { /* controls stay */ }); }
      } else if (!zVid.paused) zVid.pause();
      isV = isV && !zVid.__cwErr;
      zVid.hidden = !isV;
    }
    zImg.hidden = isV;
    zStage.classList.toggle('is-video', isV);
    if (zToggle) zToggle.hidden = isV;
    if (isV) { var c0 = qs('[data-cw-zoom-count]', zoom); if (c0) c0.textContent = (zi + 1) + ' / ' + slides.length; setZoomed(false); return; }
    zImg.src = slides[zi].getAttribute('data-cw-zoom-src') || img.currentSrc || img.src;
    zImg.alt = img.alt;
    if (img.getAttribute('width')) zImg.setAttribute('width', img.getAttribute('width'));
    if (img.getAttribute('height')) zImg.setAttribute('height', img.getAttribute('height'));
    var c = qs('[data-cw-zoom-count]', zoom); if (c) c.textContent = (zi + 1) + ' / ' + slides.length;
    setZoomed(false);
  }
  function focusables() {
    return qsa('button:not([disabled]):not([hidden]), [href], [tabindex]:not([tabindex="-1"])', zoom).filter(function (el) { return el.offsetParent !== null; });
  }
  function openZoom(i, opener) {
    if (!zoom || !zImg) return;
    zoomShow(i);
    zOpener = opener || document.activeElement;
    zoom.hidden = false;
    zPrevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    vSync();
    requestAnimationFrame(function () { zoom.classList.add('is-open'); });
    var card = qs('.cw-zoom__card', zoom);
    var first = zToggle && !zToggle.hidden ? zToggle : card;
    setTimeout(function () { (first || card).focus(); }, 30);
  }
  function closeZoom() {
    if (!zoom || zoom.hidden) return;
    zoom.classList.remove('is-open');
    zoom.hidden = true;
    if (zVid && !zVid.paused) zVid.pause();
    document.documentElement.style.overflow = zPrevOverflow;
    vSync();
    if (zOpener && typeof zOpener.focus === 'function') zOpener.focus();
  }
  if (zoom) {
    zoom.addEventListener('click', function (e) {
      if (e.target.closest('[data-cw-zoom-close]')) { closeZoom(); return; }
      var s = e.target.closest('[data-cw-zoom-step]');
      if (s) { zoomShow(zi + Number(s.getAttribute('data-cw-zoom-step'))); return; }
      if (e.target.closest('[data-cw-zoom-toggle]')) { setZoomed(!zStage.classList.contains('is-zoomed')); return; }
      if (e.target === zImg && !zImg.hidden) {
        var on = !zStage.classList.contains('is-zoomed');
        var r = zImg.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
        setZoomed(on);
        if (on) { zStage.scrollLeft = fx * zStage.scrollWidth - zStage.clientWidth / 2; zStage.scrollTop = fy * zStage.scrollHeight - zStage.clientHeight / 2; }
      }
    });
    zoom.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeZoom(); return; }
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); zoomShow(zi + (e.key === 'ArrowRight' ? 1 : -1)); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var a = f[0], b = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === a || !zoom.contains(document.activeElement))) { e.preventDefault(); b.focus(); }
        else if (!e.shiftKey && document.activeElement === b) { e.preventDefault(); a.focus(); }
      }
    });
  }

  /* ---------- format, price, quantity, stock, shipping ---------- */
  var qty = qs('[data-cw-qty]');
  function checked() { return form ? qs('input[name="id"]:checked', form) : null; }
  function selected() { var r = checked(); return r ? variantById(r.value) : null; }
  function pay(v) { return typeof v.ship === 'number' ? v.ship : v.price; }
  function getQty() {
    var n = parseInt(qty && qty.value, 10);
    return isNaN(n) ? 1 : Math.max(1, Math.min(20, n));
  }
  var shipBox = qs('[data-cw-pdp-ship]');
  var cartTotal = shipBox ? Number(shipBox.getAttribute('data-cart')) || 0 : 0;
  function updateShip(v) {
    if (!shipBox || shipBox.hasAttribute('data-off')) return;
    var T = Number(shipBox.getAttribute('data-threshold')) || 0;
    if (!T) return;
    var txt = qs('[data-cw-pdp-ship-text]', shipBox), bar = qs('[data-cw-pdp-ship-bar]', shipBox);
    var ok = !!(v && v.available && D.available);
    // Shopify Bundles product (data-bundle): only the wording changes; "ship" = the variant price (saving already in it)
    var bpct = shipBox.hasAttribute('data-bundle');
    var flat = Number(shipBox.getAttribute('data-flat')) || 0;
    var unit = ok ? (typeof v.ship === 'number' ? v.ship : v.price) : 0;
    var line = unit * getQty();
    var after = cartTotal + line, gap = T - after;
    var html;
    if (cartTotal >= T) html = 'La spedizione in Italia è già gratuita con il tuo carrello';
    else if (!ok) html = 'Spedizione gratuita in Italia da <span class="cw-num">' + money(T) + '</span> · nel carrello <span class="cw-num">' + money(cartTotal) + '</span>';
    else if (gap <= 0) html = bpct ? 'Spedizione gratuita inclusa' : 'Con questo prodotto la spedizione in Italia è gratuita';
    else if (bpct && flat) html = 'Spedizione in Italia <span class="cw-num">' + money(flat) + '</span>, gratuita da <span class="cw-num">' + money(T) + '</span>: ti mancano <b class="cw-num">' + money(gap) + '</b>';
    else html = 'Spedizione gratuita in Italia da <span class="cw-num">' + money(T) + '</span> · con questo prodotto ti mancano <b class="cw-num">' + money(gap) + '</b>';
    if (txt) txt.innerHTML = html;
    if (bar) bar.style.width = Math.min(100, Math.round(after / T * 100)) + '%';
  }
  function update() {
    var v = selected();
    if (!v) return;
    var ok = !!(v.available && D.available);
    // v.ship = v.price (bundles included since 20/10/2026: the saving is in the bundle price): what the cart charges
    qsa('[data-cw-pdp-line]').forEach(function (el) { el.textContent = money(pay(v) * getQty()); });
    var st = qs('[data-cw-pdp-stock]');
    if (st) { st.setAttribute('data-state', ok ? 'in' : 'out'); st.textContent = ok ? 'Disponibile' : D.available ? 'Questo formato è esaurito' : 'Esaurito in tutti i formati'; }
    qsa('[data-cw-qty-step], [data-cw-qty]').forEach(function (b) { b.disabled = !ok; });
    updateShip(v);
  }
  function syncVariant(say) {
    var r = checked();
    var v = r && variantById(r.value);
    if (!v) return;
    var ok = !!(v.available && D.available);
    qsa('[data-cw-pdp-price]').forEach(function (el) { el.textContent = money(pay(v)); });
    // Shopify Bundles product: struck = live sum of the singles (v.bref, "acquistando i prodotti singolarmente"), never a previous price
    var bOk = Number(v.bpct) >= 1 && Number(v.bref) > v.price;
    qsa('[data-cw-pdp-bref]').forEach(function (el) { el.hidden = !bOk; });
    qsa('[data-cw-pdp-was]').forEach(function (el) { el.textContent = bOk ? money(v.bref) : ''; });
    qsa('[data-cw-pdp-bsave]').forEach(function (el) { el.textContent = bOk ? money(v.bref - v.price) : ''; });
    qsa('[data-cw-pdp-bpct]').forEach(function (el) { el.textContent = bOk ? '\u2212' + v.bpct + '%' : ''; });
    qsa('[data-cw-pdp-format]').forEach(function (el) { el.textContent = v.label || 'Formato unico'; });
    var unit = qs('[data-cw-pdp-unit]'); if (unit) unit.textContent = v.label || '';
    // strike-through + "−N%" badge (PDP and sticky) + Omnibus line: v.cmp / v.pct are 0 unless the format has a real
    // reduction (snippets/cw-disc.liquid, cw-config discount_badge_active; never on bundles)
    var pct = v.cmp > v.price ? (Number(v.pct) || Math.floor((v.cmp - v.price) * 100 / v.cmp)) : 0;
    qsa('[data-cw-pdp-cmp]').forEach(function (el) {
      el.hidden = pct < 1;
      var x = qs('[data-cw-pdp-cmp-v]', el); if (x) x.textContent = pct >= 1 ? money(v.cmp) : '';
    });
    qsa('[data-cw-disc]').forEach(function (el) {
      el.hidden = pct < 1;
      var x = qs('[data-cw-disc-v]', el); if (x) x.textContent = pct >= 1 ? '\u2212' + pct + '%' : '';
    });
    qsa('[data-cw-disc-omni]').forEach(function (el) {
      el.hidden = pct < 1;
      var x = qs('[data-cw-disc-omni-v]', el); if (x) x.textContent = pct >= 1 ? money(v.cmp) : '';
    });
    qsa('[data-cw-pdp-submit]').forEach(function (b) { b.disabled = !ok; if (ok) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true'); });
    qsa('[data-cw-sticky-select]').forEach(function (s) { s.value = String(v.id); });
    var sib = qs('[data-cw-pdp-sibling]');
    if (sib) {
      var isT = String(v.id) === sib.getAttribute('data-travel-variant');
      var on = qs('[data-cw-sib-on]', sib), off = qs('[data-cw-sib-off]', sib);
      if (on) on.hidden = !isT;
      if (off) off.hidden = isT;
      sib.classList.toggle('is-on', isT);
    }
    update();
    if (say) {
      showVariantMedia(v, false);
      announce((v.label ? v.label + ' · ' : '') + money(v.price) + (pct >= 1 ? ' · sconto del ' + pct + '%' : '') + (ok ? '' : ' · esaurito'));
      if (D.variants.length > 1) {
        try { history.replaceState(history.state, '', location.pathname + '?variant=' + v.id + location.hash); } catch (e) { /* ignore */ }
      }
      document.dispatchEvent(new CustomEvent('cw:variant-change', { detail: { product: D, variant: v, form: form } }));
    }
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (form && t.name === 'id' && t.form === form) { syncVariant(true); return; }
    if (t.matches && t.matches('[data-cw-sticky-select]')) {
      var f = document.getElementById(t.getAttribute('data-form'));
      var radio = f && qs('input[name="id"][value="' + t.value + '"]', f);
      if (radio && !radio.disabled) { radio.checked = true; syncVariant(true); }
    }
  });
  if (qty) {
    qty.addEventListener('input', update);
    qty.addEventListener('change', function () { qty.value = String(getQty()); update(); });
    qsa('[data-cw-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        qty.value = String(Math.max(1, Math.min(20, getQty() + Number(b.getAttribute('data-cw-qty-step')))));
        update();
        announce('Quantità: ' + qty.value);
      });
    });
  }

  // Cart total for the shipping line: event detail when present, else one /cart.js read (coalesced).
  var cartReq = null;
  function refreshCart() {
    if (cartReq || !window.fetch) return;
    cartReq = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.total_price === 'number') { cartTotal = c.total_price; updateShip(selected()); } })
      .catch(function () { /* the line keeps its last value */ })
      .then(function () { cartReq = null; });
  }
  document.addEventListener('cart:refresh', function (e) {
    var c = e && e.detail && e.detail.cart;
    if (c && typeof c.total_price === 'number') { cartTotal = c.total_price; updateShip(selected()); } else refreshCart();
  });
  // Drawer swaps WITHOUT an event (e.g. the realignment after a 422 in handlePdpSubmit): observe the drawer (read-only).
  // B4 (CRO08): every add/change already emits cart:refresh with the total, so a swap that follows an event within
  // 1.5 s does not trigger a second GET /cart.js.
  var lastEvt = 0;
  document.addEventListener('cart:refresh', function () { lastEvt = Date.now(); }, true);
  var drawer = qs('[data-cart-drawer]');
  if (drawer && 'MutationObserver' in window) {
    var mt = 0;
    new MutationObserver(function () {
      clearTimeout(mt);
      mt = setTimeout(function () { if (Date.now() - lastEvt > 1500) refreshCart(); }, 150);
    }).observe(drawer, { childList: true });
  }

  /* ---------- links to closed accordions (#pdp-inci, #pdp-faq …) ---------- */
  function openHash(h) {
    var d = h && document.getElementById(h.replace(/^#/, ''));
    if (d && d.tagName === 'DETAILS') d.open = true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#pdp-"]');
    if (a && a.pathname === location.pathname) openHash(a.hash);
  });
  openHash(location.hash);

  /* ---------- "Aggiungi la routine": one gesture = ONE window.CW.addItems() call ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cw-pdp-add-items]');
    if (!b || b.disabled) return;
    var api = window.CW;
    if (!api || typeof api.addItems !== 'function') return; // no core API: the small form posts natively to /cart/add
    e.preventDefault();
    var items = [];
    try { items = JSON.parse(b.getAttribute('data-cw-pdp-add-items')); } catch (err) { items = []; }
    if (!items.length) return;
    b.setAttribute('aria-busy', 'true');
    var done = function () { b.removeAttribute('aria-busy'); };
    var res = api.addItems(items, { open: true, source: b.getAttribute('data-cw-source') || 'pdp-routine', opener: b });
    if (res && typeof res.then === 'function') res.then(done, done); else setTimeout(done, 300);
  });

  /* ---------- sticky ATC: visible when the in-page buy row is off screen ----------
     Mobile (<=899, CRO V02 19/10/2026): also from the first screen, while the in-page buy row is still BELOW the
     viewport, so the landing screen always has name + price + a way to buy (replaces QA MINOR-05 "only once the title
     block is clear": on phones the gallery is now shorter, see cw-pdp.css). Not from load when the selected format
     cannot be bought (disabled button = no action to offer); before scrolling past it the bar hides only when the
     in-page row is fully visible. .is-compact hides the bar's name line while the H1 is
     fully on screen above the bar. Display only: the add to cart stays with handlePdpSubmit() (global.js). */
  var sticky = qs('[data-cw-sticky-atc]');
  var anchor = qs('[data-cw-atc-anchor]');
  var title = qs('.cw-pdp__title');
  var sbtn = sticky && qs('[data-sticky-atc]', sticky);
  var mq = window.matchMedia && window.matchMedia('(max-width: 899px)');
  function setSticky(show) {
    if (!sticky) return;
    sticky.classList.toggle('is-visible', show);
    sticky.setAttribute('aria-hidden', String(!show));
    if (show) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
    qsa('button, select, a', sticky).forEach(function (x) { x.tabIndex = show ? 0 : -1; });
  }
  if (sticky && anchor && 'IntersectionObserver' in window) {
    var anchorIn = true, sraf = 0;
    var decide = function () {
      sraf = 0;
      var a = anchor.getBoundingClientRect();
      if (mq && mq.matches) {
        // the bar steps aside only when the in-page buy row is FULLY on screen (a sliver at the fold is not a way to buy)
        var canBuy = !sbtn || !sbtn.disabled;
        var full = a.top >= 0 && a.bottom <= window.innerHeight;
        setSticky(!full && (a.top < 0 || canBuy));
        var t = title && title.getBoundingClientRect();
        sticky.classList.toggle('is-compact', !!t && t.top >= 0 && t.bottom <= window.innerHeight - 64);
      } else {
        setSticky(!anchorIn && a.top < 0);
      }
    };
    var ask = function () { if (!sraf) sraf = requestAnimationFrame(decide); };
    new IntersectionObserver(function (en) { anchorIn = en[0].isIntersecting; ask(); }).observe(anchor);
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask);
    document.addEventListener('cw:variant-change', ask); // a sold-out format disables the button
  }

  /* ---------- Visti di recente (handles + gesture only in localStorage; live data from /products/<h>.js) ---------- */
  var KEY = 'cw_pdp_recent_v1';
  var seen = store.get(KEY, []);
  if (!Array.isArray(seen)) seen = [];
  seen = seen.filter(function (x) { return x && typeof x.h === 'string'; });
  var tvh = function (h) { return String(h).replace(/-copia$/, '-travel'); }; // P2 28/10: -copia and -travel = same product
  var oseen = {};
  var others = seen.filter(function (x) { var k = tvh(x.h); if (k === tvh(D.handle) || oseen[k]) return false; oseen[k] = 1; return true; }).slice(0, 4);
  store.set(KEY, [{ h: D.handle, g: D.gesture || '' }].concat(seen.filter(function (x) { return tvh(x.h) !== tvh(D.handle); })).slice(0, 8));
  var rec = qs('[data-cw-recent]');
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var MARK = { '01': ['01', 'Detergere'], '02': ['02', 'Tonificare e trattare'], '03': ['03', 'Nutrire'], '04': ['04', 'Proteggere'], settimana: [null, 'Una volta a settimana'], sguardo: [null, 'Sguardo e labbra'], corpo: [null, 'Corpo e mani'] };
  function markHTML(k) {
    var m = MARK[k];
    if (!m) return '';
    return '<span class="cw-mark cw-mark--compact" data-cw-gesture="' + esc(k) + '">' + (m[0] ? '<span class="cw-mark__n">' + m[0] + '</span>' : '') + '<span class="cw-sr">' + esc(m[1]) + '</span></span>';
  }
  function titleCase(t) {
    return String(t || '').split(' ').filter(function (w) { return w && w !== '-' && w !== '–'; }).map(function (w) {
      if (w === w.toUpperCase() && w !== w.toLowerCase() && !/\d/.test(w) && !/^(SPF|UV|INCI|AHA|BHA|PHA)$/.test(w)) return w.charAt(0) + w.slice(1).toLowerCase();
      return w;
    }).join(' ');
  }
  function fillRecent() {
    if (!rec || !others.length || !window.fetch) return;
    // P2 28/10: a stored Travel handle «-copia» renamed to «-travel» in Admin is retried with the new handle
    function getP(h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    Promise.all(others.map(function (x) {
      return getP(x.h)
        .then(function (p) { return p || !/-copia$/.test(x.h) ? p : getP(x.h.replace(/-copia$/, '-travel')); })
        .then(function (p) { return p ? { p: p, g: x.g } : null; });
    })).then(function (list) {
      list = list.filter(Boolean);
      if (!list.length) return;
      qs('[data-cw-recent-list]', rec).innerHTML = list.map(function (x) {
        var p = x.p;
        var av = (p.variants || []).filter(function (v) { return v.available; });
        var min = av.length ? Math.min.apply(null, av.map(function (v) { return v.price; })) : 0;
        var price = !p.available || !av.length ? 'Esaurito' : (av.length > 1 ? 'da ' : '') + money(min);
        // reduction: same cw-disc rule as the cards, read from the Liquid catalog (#cw-catalog pc/ds via CW.product)
        // Omnibus: the strike-through is printed ONLY together with the «Prezzo più basso degli ultimi 30 giorni» line
        // (same wording as the PDP, sections/main-product.liquid); the reference is the cw-disc one (pc, or ds[1]).
        var CWG = cwg();
        var cp = p.available && av.length && CWG && typeof CWG.product === 'function' && typeof CWG.discHTML === 'function' ? CWG.product(p.handle) : null;
        var dh = cp && (cp.pc || cp.ds) ? CWG.discHTML(cp) : '';
        var ref = dh ? Number(cp.pc || String(cp.ds).split('|')[1]) : 0;
        if (dh && ref > 0) {
          price = (cp.pc ? (av.length > 1 ? 'da ' : '') + money(cp.pf) : price) + dh
            + '<span class="cw-disc-omni">Prezzo più basso degli ultimi 30 giorni: <span class="cw-num">' + money(ref) + '</span></span>';
        }
        var img = p.featured_image ? String(p.featured_image).replace(/^http:/, 'https:') : '';
        if (img) img += (img.indexOf('?') < 0 ? '?' : '&') + 'width=160';
        return '<li><a class="cw-recent__item" href="' + esc(p.url || '/products/' + p.handle) + '"><span class="cw-recent__img cw-ratio cw-ratio--45">'
          + (img ? '<img src="' + esc(img) + '" alt="" width="160" height="200" loading="lazy" decoding="async">' : '') + '</span>'
          + '<span class="cw-recent__body">' + markHTML(x.g) + '<span class="cw-recent__name">' + esc(titleCase(p.title)) + '</span><span class="cw-recent__price cw-num">' + price + '</span></span></a></li>';
      }).join('');
      rec.hidden = false;
    });
  }
  if (rec && others.length) {
    if ('IntersectionObserver' in window) {
      var rio = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { rio.disconnect(); fillRecent(); } }, { rootMargin: '600px 0px' });
      // the section is hidden (no box): observe the previous section instead
      var probe = rec.parentElement && rec.parentElement.previousElementSibling || rec.parentElement || rec;
      rio.observe(probe);
    } else fillRecent();
  }

  syncVariant(false);
  // ?variant= deep link: the gallery opens on the selected variant's photo (no ?variant= = first slide, the LCP)
  if (/[?&]variant=\d/.test(location.search)) showVariantMedia(selected(), true);
})();
